import { useState } from 'react'
import IntroAnimation from '../../organisms/IntroAnimation/IntroAnimation'
import HeroSection from '../../molecules/HeroSectiongostor/HeroSection'
import StatsSection from '../../molecules/StatsSection/StatsSection'
import OverviewSection from '../../molecules/OverviewSection/OverviewSection'
import ChallengesSection from '../../molecules/ChallengesSection/ChallengesSection'
import OutcomeSection from '../../molecules/OutcomeSection/OutcomeSection'
import SolutionSection from '../../molecules/SolutionSection/SolutionSection'
import FeatureSection from '../../molecules/FeatureSection/FeatureSection'
import Message from '../../molecules/Message/Message'
import Questions from '../../molecules/Questions/Questions'
import Footer from '../../organisms/Footer/Footer'
import Testimonial from '../../molecules/Testimonial/Testimonial'
import gostoranimation from '../../../assets/images/projectportfolio/gostoranimation.webp'

const PortfolioProjectPage = () => {
  const [startAnimation, setStartAnimation] = useState(false)
  const [introKey] = useState(() => Date.now())

  return (
    <div className="relative min-h-screen bg-[#070908] flex flex-col overflow-hidden">

<IntroAnimation
key={introKey}
        words={['E-COMMERCE', 'PLATFORM']}
        wordColors={['#3a9545', '#3a9545']}
        backgroundGradient={{
          top: '#e2f0d6',
          bottom: '#bdceaf',
        }}
        onHeroStart={() => setStartAnimation(true)}
      />
      

      <div className="absolute -left-43 top-180 h-[650px] w-[700px] rounded-full bg-[#8FE64A]/10 blur-3xl" />

      <HeroSection startAnimation={startAnimation} />
      <StatsSection />
      <OverviewSection />
      <ChallengesSection />
      <OutcomeSection />
      <SolutionSection />
      <FeatureSection />

      <Testimonial className="mx-auto mb-20 max-w-[90%]" showHeader themeColor="green" />

      <div className="mb-10 px-4 md:px-8 2xl:mx-20 xl:px-12">
        <div className="grid w-full grid-cols-1 gap-5 xl:min-h-[620px] 2xl:min-h-[710px] lg:grid-cols-[1fr_1fr] xl:grid-cols-[1fr_2fr]">
          
          <Message themeColor="green" />
          <Questions themeColor="green" />
        </div>
      </div>

      <Footer />
    </div>
  )
}

export default PortfolioProjectPage